import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  //https://materialdesignicons.com/
  //https://vuetifyjs.com/en/features/icon-fonts/#reusable-custom-icons
  //https://icon-sets.iconify.design/mdi/logout-variant/
  icons: {
    iconfont: "mdi", // default
    values: {
      logout: "mdi-logout-variant",
    },
  },
  theme: {
    themes: {
      light: {
        primary: "#117973",
        primary2: "#083C39",
        teacherPrimary: "#228E6E",
        teacherSecondary: "#F1FFFB",
        white: "#FFFFFF",
        secondary: "#E9FFFE",
        orange: "#F15A22",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
    },
  },
});

export default new Vuetify({});
